"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
const v4_1 = require("zod/v4");
exports.UIConfigSchema = v4_1.z.object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
    externalFilename: v4_1.z.string().describe('External filename'),
    creditFacilitySlug: v4_1.z.string().nullable().describe('Credit facility slug'),
    loanProductSlug: v4_1.z.string().nullable().describe('Loan product slug'),
    encryptionConfig: finley_types_1.Util.EncryptionConfigSchema.optional().describe('Encryption config'),
    outputFileExtension: finley_types_1.Util.SupportedFileExtensionSchema.optional().describe('Explicit output file extension'),
    uploadConfig: tape_builder_base_1.RawUploadConfigSchema.optional().describe('Optional configuration for uploading a file on BBPL monitor.'),
    unzipFilter: v4_1.z
        .string()
        .optional()
        .describe('Regular expression to match the files to be unzipped. If filter is specified only files matching the given filter will be unzipped. If filter is not specified all files will be unzipped.'),
});
exports.nodeType = 'file_rawZipTape';
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
    externalFilename: true,
    creditFacilitySlug: true,
    loanProductSlug: true,
});
exports.artifactType = 'rawZipTape';
//# sourceMappingURL=types.js.map